import { render } from "./Faturamento.vue?vue&type=template&id=705ac0ef"
import script from "./Faturamento.vue?vue&type=script&lang=ts"
export * from "./Faturamento.vue?vue&type=script&lang=ts"
script.render = render

export default script